<div class="container px-0 pt-5 mt-md-3">
  <div class="row">
    <div class="col-9"><h1>{{translationPrefix + '.content.heading' | translate}}</h1></div>
    <div class="col-3 d-none d-md-block">
      <button (click)="navigateDashboard()" class="btn btn-outline-success btn-lg btn-block"
              type="button">{{ 'wizard.actions.back' | translate }}</button>
    </div>
  </div>

  <div *ngFor="let requirement of requirements" class="row">
    <div [innerHTML]="translationPrefix + '.content.requirements.' + requirement + '.heading' | translate"
         class="col-12"></div>
    <div [innerHTML]="translationPrefix + '.content.requirements.' + requirement + '.content' | translate"
         class="col-12">
    </div>
  </div>

  <div class="row mt-md-5 mt-3 pb-md-3 text-center">
    <div class="col-12 mb-3" *ngIf="shouldShowMedicareCard"><img alt="Medicare Card" src="assets/images/medicareCard.png"></div>
    <div class="col-12"><span [innerHTML]="translationPrefix + '.content.requirements.checklist.' + applicationYear | translate"></span>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <span [innerHTML]="translationPrefix + '.notice' | translate"></span>
    </div>
  </div>

  <div class="row mt-4 justify-content-center">
    <div *ngIf="resolvedEffectiveDate" class="col-xs-12 col-sm-9 col-md-7 col-lg-6">
      <button (click)="startApplication()" class="btn btn-success btn-lg btn-block"
              type="button">{{ translationPrefix + '.actions.' + (resolvedApplication?.id ? 'continueApplication' : 'startApplication') | translate }}</button>
    </div>
  </div>

  <div class="container pt-5">
    <div class="row">
      <div class="col-12 p-0">
        <p>{{ materialId }}</p>
      </div>
    </div>
  </div>
</div>
